module.exports = __webpack_public_path__ + "img/product_battery.ca1bf305.jpg";